import { FilterableDocumentsContext } from '@/contexts/FilterableDocumentsContext';
import { Container } from '@ui';
import React from 'react';
import styled from 'styled-components';
import { DocTypeSelectBar } from '../components/DocTypeSelectBar';
import { ReportingPeriodSelectBar } from '../components/ReportingPeriodSelectBar';
import { SelectableDocumentsList } from '@containers/documents/SelectableDocumentsList';
import { FormStateContext } from '@/contexts/FormStateContext';
import { filterDuplicateCompanies, filterDuplicateDocuments } from '@utils/usefulFuncs';
import { TagSelectBar } from '../components/TagSelectBar';
import { Working } from '@ui/Working';

const Wrapper = styled.div``;
const FilterBarsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FILTERED_DOCUMENT_SELECTION_FILTERS = {
  tags: 'tags',
  documentTypes: 'documentTypes',
  reportingPeriods: 'reportingPeriods',
};

export const FilteredDocumentsSelection = ({ singleDocMode = false, filterModes = [], initializing }) => {
  const { loadingDocuments, filteredDocuments, documentTypes, reportingPeriodTypes } =
    React.useContext(FilterableDocumentsContext);
  const { state: formState, setFormStateValue } = React.useContext(FormStateContext);
  const { selectedDocs: value } = formState;

  const onChange = (value) => {
    setFormStateValue('selectedDocs', value);
  };

  const onAddTag = (tag) => {
    setFormStateValue('tags', filterDuplicateCompanies([...formState.tags, tag]));
  };

  const onRemoveDocument = (document) => {
    if (Array.isArray(document)) {
      const removeDocIds = document.map((d) => d.id);
      onChange(value.filter((d) => !removeDocIds.includes(d.id)));
    } else {
      onChange(value.filter((d) => d.id !== document.id));
    }
  };

  const onAddDocument = (document) => {
    if (Array.isArray(document)) {
      onChange(filterDuplicateDocuments([...value, ...document]));
    } else {
      onChange(filterDuplicateDocuments([...value, document]));
    }
  };

  if (initializing) {
    return <Working />;
  }

  return (
    <Wrapper>
      <FilterBarsWrapper>
        {filterModes.includes(FILTERED_DOCUMENT_SELECTION_FILTERS.tags) && (
          <TagSelectBar tags={formState.tags} onAddTag={onAddTag} />
        )}
        {filterModes.includes(FILTERED_DOCUMENT_SELECTION_FILTERS.documentTypes) && (
          <DocTypeSelectBar documentTypes={documentTypes} />
        )}
        {filterModes.includes(FILTERED_DOCUMENT_SELECTION_FILTERS.reportingPeriods) && (
          <ReportingPeriodSelectBar reportingPeriodTypes={reportingPeriodTypes} />
        )}
      </FilterBarsWrapper>

      <Container top={16}>
        {loadingDocuments ? (
          <Working />
        ) : (
          <SelectableDocumentsList
            docs={filteredDocuments}
            selectedDocs={value}
            onSelect={onAddDocument}
            onRemoveSelect={onRemoveDocument}
            singleDocMode={singleDocMode}
          />
        )}
      </Container>
      <Container top={100} />
    </Wrapper>
  );
};
